import { RemovePillData, TextValue } from '@shared/interfaces';
import { Subject } from 'rxjs';
import { FilterPill } from './table-filter-pill.class';

export class MultiSelectFilter extends FilterPill {
    private composeFilterPillsMultiselectValues(filterValues: number[], textValues: TextValue[]) {
        return filterValues.map(v => {
            const el = textValues.find(el => el.value === v);

            return {
                label: el?.text || '',
                value: el?.value ?? 0,
            };
        });
    }

    private removeMultiselectFilter(data: RemovePillData, multiFilter: number[]) {
        if (data.removeAll) {
            return [];
        } else {
            const result = multiFilter;
            const index = multiFilter.findIndex(el => el === data.id);
            result.splice(index, 1);
            return [...result];
        }
    }

    override updateState(
        multiSelectFilterValues: number[],
        multiSelectPrepareData: TextValue[],
        debounce?: Subject<void>
    ) {
        this.hasOverlay = multiSelectFilterValues.length > 1;
        this.values = this.composeFilterPillsMultiselectValues(multiSelectFilterValues, multiSelectPrepareData);
        this.onRemove = data => {
            const newValues = this.removeMultiselectFilter(data, multiSelectFilterValues);
            this.updateState(newValues, multiSelectPrepareData, debounce);
            debounce?.next();
        };
        this.isVisible = !!multiSelectFilterValues.length;
    }

    override getState(): number[] {
        return this.values.map(el => el.value);
    }
}
